export const links = {
  HELP_EMAIL: 'help@kaltura.com',
  SERVICE_AGREEMENT: 'https://corp.kaltura.com/legal/tos/customer-agreement/',
  PRIVACY_POLICY: 'https://corp.kaltura.com/legal/privacy/privacy-policy/',
  PRICING: 'https://corp.kaltura.com/pricing/',
  FORGOT_PASSWORD: 'https://kmc.kaltura.com/index.php/kmcng/login',
  SIGN_UP: 'https://corp.kaltura.com/free-trial-video-conference/',
};
